<template>
  <base-modal
    width="600px"
    height="600px"
  >
    <template #header>{{ t(`policy.${policyTitle}`) }}</template>
    <template #body>
      <section class="h-full">
        <iframe
          :src="`/policy/${policy}.html`"
          frameborder="0"
          class="w-full h-full"
        ></iframe>
      </section>
    </template>
    <template #footer>
      <button
        @click="$emit('close')"
        class="w-full"
      >
        확인
      </button>
    </template>
  </base-modal>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from 'vue';
import BaseModal from '@/components/baseComponent/BaseModal.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ModalPolicy',
  components: { BaseModal },
  props: {
    policy: {
      type: String as PropType<policyType>,
      required: true,
    },
  },
  setup: (props) => {
    const { t } = useI18n();
    const { policy } = toRefs(props);

    const policyTitle = computed(() => {
      if (policy.value === 'service' || policy.value === 'serviceNew') return 'title-service';
      if (policy.value === 'privacy') return 'title-privacy';
      if (policy.value === 'marketing') return 'title-marketing';
      if (policy.value === 'consulting') return 'title-privacy';
      if (policy.value === 'itemPolicy' || policy.value.includes('Policy')) return 'title-itemPolicy';
    });

    return {
      t,
      policy,
      policyTitle,
    };
  },
});
</script>

<style lang="scss" scoped></style>
